import * as React from 'react'

import { Box, Icon, List, Tooltip, useToggle } from '@factorialco/deprecated-design-system'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import WorkplacesActions from '../WorkplacesActions'

interface Props {
  locationName: string
  isLocationDefault: boolean
  employeeId: number
  accessId: number
  locationId: number
  canAssignLocations: boolean
  onDefaultLocationUpdated: (id: number) => void
}

const WorkplacesListItem = ({
  locationName,
  isLocationDefault,
  employeeId,
  accessId,
  locationId,
  canAssignLocations,
  onDefaultLocationUpdated,
}: Props) => {
  const [open, toggle] = useToggle(false)

  const { navigation } = useNavigation()

  const getTo = navigation.settings.locations.locationsId.details.fullPath({ id: locationId })

  return (
    <List.Item>
      <Box
        flexDirection="row"
        alignItems="center"
        width="full"
        justifyContent="spaceBetween"
        gap="s24"
      >
        <Box flexDirection="row" minWidth="none" gap="s8">
          {isLocationDefault && <Icon.Medium icon="star" />}

          <Tooltip
            attachment="middle left"
            targetAttachment="middle right"
            type="black"
            size="small"
            open={open}
            toggle={toggle}
          >
            <List.Title ellipsis>{locationName}</List.Title>
            <div>{locationName}</div>
          </Tooltip>
        </Box>
        <WorkplacesActions
          to={getTo}
          employeeId={employeeId}
          accessId={accessId}
          isLocationDefault={isLocationDefault}
          locationId={locationId}
          canAssignLocations={canAssignLocations}
          onDefaultLocationUpdated={onDefaultLocationUpdated}
        />
      </Box>
    </List.Item>
  )
}

export default WorkplacesListItem
